import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";

export const CareerSave = async (b, userId, compID) => {
        const postData = {
            name: b.name,
            position: b.position,
            location: b.location,
            overview: b.overview,
            qualification: b.qualification,
            description: b.description,
            perks_benefits: b.perks_benefits,
            status: 2,
            banner: b.banner,
            logo: b.logo,
            company_id: compID,
            user_id: userId,
            start_date: new Date(),
            end_date: "2026-12-30",
            deployment: b.deployment,
            employment: b.employment
        };
      
        const response = await rqx.post(
            `<<tool>>/${env()}/careerpost/create`,
            postData
        );

        return response;
};